module.exports = __webpack_public_path__ + "static/media/drawBanner.11d3b5f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/drawBanner.jpg
// module id = 297
// module chunks = 0